/**
 * Whether a completed agent tool call changed server data, so the Provider App
 * should refresh what it is showing. Any GraphQL mutation tool qualifies, as
 * does a document template file edit.
 */
export const isDataRefreshingToolName = (toolName: string): boolean =>
  toolName.toLowerCase().includes('mutation') || toolName === 'edit_file';
